import { patientApi } from '@/api/PatientApi'
import { providerApi } from '@/api/ProviderApi'
import { useAuthStore } from '@/store'
import { useQueryClient } from '@tanstack/react-query'

const reportAvailabilityQuery = {
	queryKey: ['latest-patient-appointment-results'],
	queryFn: () => providerApi.fetchLatestAppointmentResults(),
}

const membershipStatusQuery = {
	queryKey: ['patient-membership-status'],
	queryFn: () => patientApi.getMembershipStatus(),
}

const AppQueryPreloader = ({ children }: { children: React.ReactNode }) => {
	const queryClient = useQueryClient()
	const { isAuthenticated } = useAuthStore()

	if (isAuthenticated) {
		queryClient.prefetchQuery(reportAvailabilityQuery)
		queryClient.prefetchQuery(membershipStatusQuery)
	}

	return children
}

export { AppQueryPreloader }
